import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useModal } from '../../hooks/useModal';

const Modals: React.FC = () => {
  const {
    showUserTypeModal,
    showClientModal,
    showFreelancerModal,
    selectedUserType,
    closeUserTypeModal,
    closeClientModal,
    closeFreelancerModal,
    setSelectedUserType,
    handleUserTypeSelection,
  } = useModal();

  const handleUserTypeSelect = (userType: string) => {
    setSelectedUserType(userType);
  };

  const validateFullName = (fullName: string): boolean => {
    const words = fullName.split(' ');
    return words.length >= 2 || fullName.length >= 5;
  };

  const validateEmail = (email: string): boolean => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const handleClientFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const fullName = (form.elements.namedItem('entry.2118285381') as HTMLInputElement)?.value || '';
    const email = (form.elements.namedItem('entry.1022476017') as HTMLInputElement)?.value || '';
    const country = (form.elements.namedItem('country') as HTMLSelectElement)?.value || '';
    const description = (form.elements.namedItem('entry.2132015202') as HTMLTextAreaElement)?.value || '';
    const termsChecked = (form.elements.namedItem('termsCheck') as HTMLInputElement)?.checked || false;

    if (!validateFullName(fullName)) {
      Swal.fire({
        title: 'Error!',
        html: '<p class="custom-swal-text">Full Name must have at least two words or be 5 characters long</p><button class="main-button mt-2 px-4 py-2" id="error-ok-btn" style="border-radius:5px;">OK</button>',
        icon: 'error',
        showConfirmButton: false,
        customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
        didOpen: () => {
          const errorOkButton = document.getElementById('error-ok-btn');
          errorOkButton?.addEventListener('click', () => Swal.close());
        }
      });
      return;
    }

    if (!validateEmail(email)) {
      Swal.fire({
        title: 'Error!',
        html: '<p class="custom-swal-text">Please enter a valid email address</p><button class="main-button mt-2 px-4 py-2" id="error-ok-btn" style="border-radius:5px;">OK</button>',
        icon: 'error',
        showConfirmButton: false,
        customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
        didOpen: () => {
          const errorOkButton = document.getElementById('error-ok-btn');
          errorOkButton?.addEventListener('click', () => Swal.close());
        }
      });
      return;
    }

    if (country === "") {
      Swal.fire({
        title: 'Error!',
        html: '<p class="custom-swal-text">Please Select a country</p><button class="main-button mt-2 px-4 py-2" id="error-ok-btn" style="border-radius:5px;">OK</button>',
        icon: 'error',
        showConfirmButton: false,
        customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
        didOpen: () => {
          const errorOkButton = document.getElementById('error-ok-btn');
          errorOkButton?.addEventListener('click', () => Swal.close());
        }
      });
      return;
    }

    if (description.length < 10) {
      Swal.fire({
        title: 'Error!',
        html: '<p class="custom-swal-text">Description must be at least 10 characters long</p><button class="main-button mt-2 px-4 py-2" id="error-ok-btn" style="border-radius:5px;">OK</button>',
        icon: 'error',
        showConfirmButton: false,
        customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
        didOpen: () => {
          const errorOkButton = document.getElementById('error-ok-btn');
          errorOkButton?.addEventListener('click', () => Swal.close());
        }
      });
      return;
    }

    if (!termsChecked) {
      Swal.fire({
        title: 'Error!',
        html: '<p class="custom-swal-text">You must agree to the Terms of Service and Privacy Policy</p><button class="main-button mt-2 px-4 py-2" id="error-ok-btn" style="border-radius:5px;">OK</button>',
        icon: 'error',
        showConfirmButton: false,
        customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
        didOpen: () => {
          const errorOkButton = document.getElementById('error-ok-btn');
          errorOkButton?.addEventListener('click', () => Swal.close());
        }
      });
      return;
    }

    Swal.fire({
      title: 'Success!',
      html: '<p class="custom-swal-text">You have successfully joined the waitlist!</p><button class="main-button mt-2 px-4 py-2" id="custom-ok-btn" style="border-radius:5px;">OK</button>',
      icon: 'success',
      showConfirmButton: false,
      customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
      didOpen: () => {
        const customOkButton = document.getElementById('custom-ok-btn');
        customOkButton?.addEventListener('click', () => {
          Swal.close();
          window.location.href = '/';
        });
      }
    });

    try {
      await fetch(form.action, {
        method: form.method,
        body: formData
      });
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  const handleFreelancerFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const fullName = (form.elements.namedItem('entry.2118285381') as HTMLInputElement)?.value || '';
    const email = (form.elements.namedItem('entry.1022476017') as HTMLInputElement)?.value || '';
    const country = (form.elements.namedItem('f_country') as HTMLSelectElement)?.value || '';
    const description = (form.elements.namedItem('entry.2132015202') as HTMLTextAreaElement)?.value || '';
    const termsChecked = (form.elements.namedItem('f_termsCheck') as HTMLInputElement)?.checked || false;

    if (!validateFullName(fullName)) {
      Swal.fire({
        title: 'Error!',
        html: '<p class="custom-swal-text">Full Name must have at least two words or be 5 characters long</p><button class="main-button mt-2 px-4 py-2" id="error-ok-btn" style="border-radius:5px;">OK</button>',
        icon: 'error',
        showConfirmButton: false,
        customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
        didOpen: () => {
          const errorOkButton = document.getElementById('error-ok-btn');
          errorOkButton?.addEventListener('click', () => Swal.close());
        }
      });
      return;
    }

    if (!validateEmail(email)) {
      Swal.fire({
        title: 'Error!',
        html: '<p class="custom-swal-text">Please enter a valid email address</p><button class="main-button mt-2 px-4 py-2" id="error-ok-btn" style="border-radius:5px;">OK</button>',
        icon: 'error',
        showConfirmButton: false,
        customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
        didOpen: () => {
          const errorOkButton = document.getElementById('error-ok-btn');
          errorOkButton?.addEventListener('click', () => Swal.close());
        }
      });
      return;
    }

    if (country === "") {
      Swal.fire({
        title: 'Error!',
        html: '<p class="custom-swal-text">Please Select a country</p><button class="main-button mt-2 px-4 py-2" id="error-ok-btn" style="border-radius:5px;">OK</button>',
        icon: 'error',
        showConfirmButton: false,
        customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
        didOpen: () => {
          const errorOkButton = document.getElementById('error-ok-btn');
          errorOkButton?.addEventListener('click', () => Swal.close());
        }
      });
      return;
    }

    if (description.length < 10) {
      Swal.fire({
        title: 'Error!',
        html: '<p class="custom-swal-text">Description must be at least 10 characters long</p><button class="main-button mt-2 px-4 py-2" id="error-ok-btn" style="border-radius:5px;">OK</button>',
        icon: 'error',
        showConfirmButton: false,
        customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
        didOpen: () => {
          const errorOkButton = document.getElementById('error-ok-btn');
          errorOkButton?.addEventListener('click', () => Swal.close());
        }
      });
      return;
    }

    if (!termsChecked) {
      Swal.fire({
        title: 'Error!',
        html: '<p class="custom-swal-text">You must agree to the Terms of Service and Privacy Policy</p><button class="main-button mt-2 px-4 py-2" id="error-ok-btn" style="border-radius:5px;">OK</button>',
        icon: 'error',
        showConfirmButton: false,
        customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
        didOpen: () => {
          const errorOkButton = document.getElementById('error-ok-btn');
          errorOkButton?.addEventListener('click', () => Swal.close());
        }
      });
      return;
    }

    Swal.fire({
      title: 'Success!',
      html: '<p class="custom-swal-text">You have successfully joined the waitlist!</p><button class="main-button mt-2 px-4 py-2" id="success-ok-btn" style="border-radius:5px;">OK</button>',
      icon: 'success',
      showConfirmButton: false,
      customClass: { popup: 'custom-swal-popup', title: 'custom-swal-title' },
      didOpen: () => {
        const successOkButton = document.getElementById('success-ok-btn');
        successOkButton?.addEventListener('click', () => {
          Swal.close();
          window.location.href = '/';
        });
      }
    });

    try {
      await fetch(form.action, {
        method: form.method,
        body: formData
      });
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  const countries = [
    "Afghanistan", "Akrotiri", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica",
    "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Ashmore and Cartier Islands", "Australia", "Austria",
    "Azerbaijan", "Bahamas, The", "Bahrain", "Bangladesh", "Barbados", "Bassas da India", "Belarus", "Belgium",
    "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island",
    "Brazil", "British Indian Ocean Territory", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso",
    "Burma", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic",
    "Chad", "Chile", "China", "Christmas Island", "Clipperton Island", "Cocos (Keeling) Islands", "Colombia",
    "Comoros", "Congo, Democratic Republic of the", "Congo, Republic of the", "Cook Islands", "Coral Sea Islands",
    "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Dhekelia", "Djibouti",
    "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia",
    "Ethiopia", "Europa Island", "Falkland Islands (Islas Malvinas)", "Faroe Islands", "Fiji", "Finland", "France",
    "French Guiana", "French Polynesia", "French Southern and Antarctic Lands", "Gabon", "Gambia, The",
    "Gaza Strip", "Georgia", "Germany", "Ghana", "Gibraltar", "Glorioso Islands", "Greece", "Greenland", "Grenada",
    "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti",
    "Heard Island and McDonald Islands", "Holy See (Vatican City)", "Honduras", "Hong Kong", "Hungary", "Iceland",
    "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey",
    "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan", "Laos",
    "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau",
    "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique",
    "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro",
    "Montserrat", "Morocco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia",
    "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Korea",
    "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay",
    "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda",
    "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal",
    "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia",
    "South Africa", "South Georgia and the South Sandwich Islands", "Spain", "Spratly Islands", "Sri Lanka",
    "Sudan", "Suriname", "Svalbard", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan",
    "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey",
    "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States",
    "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands", "Wake Island",
    "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"
  ];

  return (
    <>
      {/* User Type Selection Modal */}
      <Modal
        show={showUserTypeModal}
        onHide={closeUserTypeModal}
        centered
        id="modal1"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
      >
        <Modal.Body className="bg-black">
          <Button variant="close" className="bg-white float-end" onClick={closeUserTypeModal} />
          <div className="container-fluid">
            <Row>
              <Col xs={12} className="d-flex justify-content-center mb-5 mt-2">
                <img src="/assets/images/Red Combined 1 (1).png" className="img-fluid" alt="Logo" />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="text-center fs-5 my-3 fw-bold text-white">
                Join as a client or freelancer
              </Col>
            </Row>
            <Row>
              <Col xs={12} lg={12}>
                <div className="d-flex justify-content-around mt-4 text-start">
                  <div
                    className={`option-box pt-2 ${selectedUserType === 'Client' ? 'usertype' : ''}`}
                    onClick={() => handleUserTypeSelect('Client')}
                  >
                    <div className="text-start pt-4 text-white">
                      I'm a client,<br /> hiring for an<br /> event
                    </div>
                  </div>
                  <div
                    className={`option-box pt-2 ${selectedUserType === 'Freelancer' ? 'usertype' : ''}`}
                    onClick={() => handleUserTypeSelect('Freelancer')}
                  >
                    <div className="text-start pt-4 text-white">
                      I'm a<br /> freelancer,<br /> looking for<br /> work
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-5 py-5 pb-5 mx-3">
              <Col xs={12} className="text-center">
                <Button
                  disabled={!selectedUserType}
                  className="btn btn-waitlist w-100"
                  id="btnWaitlist"
                  onClick={() => handleUserTypeSelection(selectedUserType)}
                >
                  Join the Waitlist
                </Button>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>

      {/* Client Signup Modal */}
      <Modal
        show={showClientModal}
        onHide={closeClientModal}
        size="lg"
        id="clientModal"
        dialogClassName="modal-half-width"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
      >
        <Modal.Body className="bg-black">
          <Button variant="close" className="bg-white float-end" onClick={closeClientModal} />
          <Form onSubmit={handleClientFormSubmit} action="https://docs.google.com/forms/d/e/1FAIpQLSd4xEhZVLyIoNQU9bf_fO38dqifxZnCJXGDCpUQvlQyWOO7Og/formResponse" method="POST">
            <div className="container-fluid">
              <Row>
                <Col xs={12} className="d-flex justify-content-center mb-5 mt-2">
                  <img src="/assets/images/Red Combined 1 (1).png" className="img-fluid" alt="Logo" />
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-center fs-5 mb-3 text-white">
                  Join the waitlist to find and<br /> hire event professionals
                </Col>
              </Row>
              <Row>
                <input type="hidden" name="entry.1629612988" value="Client" />
                <Col xs={12} lg={12} className="mb-3">
                  <Form.Label htmlFor="fullname" className="text-white">Full Name</Form.Label>
                  <Form.Control type="text" className="form-control-sm bg-transparent text-white" id="fullname" name="entry.2118285381" />
                </Col>
                <Col xs={12} lg={12} className="mb-3">
                  <Form.Label htmlFor="email" className="text-white">Email</Form.Label>
                  <Form.Control type="email" className="form-control-sm bg-transparent text-white" id="email" name="entry.1022476017" />
                </Col>
                <Col xs={12} lg={12} className="mb-3">
                  <Form.Label htmlFor="country" className="text-white">Country</Form.Label>
                  <Form.Select className="form-select-sm bg-transparent text-white" id="country">
                    <option className="text-black" value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country} className="text-black" value={country}>{country}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={12} lg={12} className="mb-1">
                  <Form.Label htmlFor="description" className="text-white">What event do you primarily organize for?</Form.Label>
                  <Form.Control as="textarea" className="form-control-sm bg-transparent text-white" rows={3} id="description" placeholder="e.g. corporate seminars, weddings, club events, etc" name="entry.2132015202" />
                </Col>
                <Col xs={12} lg={12} className="mb-1">
                  <Form.Check type="checkbox" id="defaultCheck1" name="entry.813840678" defaultChecked label="Receive other updates and marketing emails from Whatsnxt." className="text-white" />
                </Col>
                <Col xs={12} lg={12} className="mb-1">
                  <Form.Check type="checkbox" id="termsCheck" label={
                    <>Yes, I understand and agree to the Whatsnxt <a href="https://whatsnxt.app/terms-of-service/" style={{color: 'white'}} target="_blank" rel="noopener noreferrer"> Terms of Service</a> and <a href="https://whatsnxt.app/privacy-policy/" style={{color: 'white'}} target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</>
                  } className="text-white" />
                </Col>
              </Row>
              <Row className="mt-5 py-2 pb-3 mx-2">
                <Col xs={12} className="text-center">
                  <Button type="submit" className="btn btn-waitlist w-100">
                    Join the Waitlist
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Freelancer Signup Modal */}
      <Modal
        show={showFreelancerModal}
        onHide={closeFreelancerModal}
        size="lg"
        id="freelancerModal"
        dialogClassName="modal-half-width"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
      >
        <Modal.Body className="bg-black">
          <Button variant="close" className="bg-white float-end" onClick={closeFreelancerModal} />
          <Form onSubmit={handleFreelancerFormSubmit} action="https://docs.google.com/forms/d/e/1FAIpQLSd4xEhZVLyIoNQU9bf_fO38dqifxZnCJXGDCpUQvlQyWOO7Og/formResponse" method="POST">
            <div className="container-fluid">
              <Row>
                <Col xs={12} className="d-flex justify-content-center mb-5 mt-2">
                  <img src="/assets/images/Red Combined 1 (1).png" className="img-fluid" alt="Logo" />
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="text-center fs-5 mb-3 text-white">
                  Offer your event services and<br /> grow your freelance career
                </Col>
              </Row>
              <Row>
                <input type="hidden" name="entry.1629612988" value="Freelancer" />
                <Col xs={12} lg={12} className="mb-3">
                  <Form.Label htmlFor="f_fullname" className="text-white">Full Name</Form.Label>
                  <Form.Control type="text" className="form-control-sm bg-transparent text-white" id="f_fullname" name="entry.2118285381" />
                </Col>
                <Col xs={12} lg={12} className="mb-3">
                  <Form.Label htmlFor="f_email" className="text-white">Email</Form.Label>
                  <Form.Control type="email" className="form-control-sm bg-transparent text-white" id="f_email" name="entry.1022476017" />
                </Col>
                <Col xs={12} lg={12} className="mb-3">
                  <Form.Label htmlFor="f_country" className="text-white">Country</Form.Label>
                  <Form.Select className="form-select-sm bg-transparent text-white" id="f_country">
                    <option className="text-black" value="">Select Country</option>
                    {countries.map((country) => (
                      <option key={country} className="text-black" value={country}>{country}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={12} lg={12} className="mb-1">
                  <Form.Label htmlFor="f_description" className="text-white">What event services do you offer?</Form.Label>
                  <Form.Control as="textarea" className="form-control-sm bg-transparent text-white" rows={3} id="f_description" placeholder="e.g photography, catering, makeup, event planning, etc" name="entry.2132015202" />
                </Col>
                <Col xs={12} lg={12} className="mb-1">
                  <Form.Check type="checkbox" id="f_defaultCheck1" name="entry.813840678" defaultChecked label="Receive other updates and marketing emails from Whatsnxt." className="text-white" />
                </Col>
                <Col xs={12} lg={12} className="mb-1">
                  <Form.Check type="checkbox" id="f_termsCheck" label={
                    <>Yes, I understand and agree to the Whatsnxt <a href="https://whatsnxt.app/terms-of-service/" style={{color: 'white'}} target="_blank" rel="noopener noreferrer">Terms of Service</a> and <a href="https://whatsnxt.app/privacy-policy/" style={{color: 'white'}} target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</>
                  } className="text-white" />
                </Col>
              </Row>
              <Row className="mt-5 py-2 pb-3 mx-2">
                <Col xs={12} className="text-center">
                  <Button type="submit" className="btn btn-waitlist w-100">
                    Join the Waitlist
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Modals;
